import React, { Component } from 'react';
import withWidth from '@material-ui/core/withWidth';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';

import Icon from 'src/components/icon';

import './mobile-menu.scss';

class MobileMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            active: false,
        };
    }

    toggleMenu = () => {
        this.setState(prevState => ({ active: !prevState.active }));
    };

    render() {
        const { width, ...rest } = this.props;
        const { active } = this.state;

        if (width !== 'sm' && width !== 'xs') {
            return null;
        }

        return (
            <div className="MobileMenu" {...rest}>
                <div className="menu-icon" onClick={this.toggleMenu}>
                    <Icon code="bars" size={24} color="#7a8186" />
                </div>
                <div className={classnames('menu-wrapper', { active })}>
                    <div className="overlay" onClick={this.toggleMenu} />
                    <div className="menu">
                        <ul>
                            <li>
                                <NavLink
                                    activeClassName="active"
                                    to="/admin/dashboard"
                                    onClick={this.toggleMenu}
                                >
                                    <Icon code="chart-pie" color="#716392" />
                                    Dashboard
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    activeClassName="active"
                                    to="/admin/debtors"
                                    onClick={this.toggleMenu}
                                >
                                    <Icon code="user" color="#716392" />
                                    Devedores
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    activeClassName="active"
                                    to="/admin/requests"
                                >
                                    <Icon code="exclamation" color="#B7C7D2" size={16} />
                                    Pendências
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    activeClassName="active"
                                    to="/admin/deals"
                                    onClick={this.toggleMenu}
                                >
                                    <Icon code="arrow-circle-down" color="#716392" />
                                    Acordos
                                </NavLink>
                            {/* todo: create surveys mobile menu */}
                            </li>
                            <li>
                                <NavLink
                                    activeClassName="active"
                                    to="/admin/surveys"
                                >
                                    <Icon code="handshake" color="#716392" />
                                    Pesquisas
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    activeClassName="active"
                                    to="/admin/config"
                                    onClick={this.toggleMenu}
                                >
                                    <Icon code="arrow-circle-down" color="#716392" />
                                    Configurações
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }

}

export default withWidth()(MobileMenu);
